import { useCallback, useEffect, useState } from "react";

import { CheckCircle, ChevronLeft } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  IconButton,
  TablePagination,
  Typography,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { connect, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import InviteCandidatesModal from "../../components/Modals/InviteCandidatesModal";
// import UploadResumesModal from '../../components/Modals/UploadResumesModal';
import SelectAssesmentAndCriteriaModal from "../../components/Modals/SelectAssesmentAndCriteriaModal";
import SelectLanguageModal from "../../components/Modals/SelectAssesmentAndCriteriaModal/SelectLanguageModal";
import ResumeScreeningCandidatesTable from "../../components/ResumeScreening/ResumeScreeningCandidatesTable";
import ResumeScreeningCandidatesTableHeader from "../../components/ResumeScreening/ResumeScreeningCandidatesTableHeader";
import {
  clearPostFormData as clearPostFormDataAction,
  getSinglePost as getSinglePostAction,
  selectPostById,
  updatePostFormData as updatePostFormDataAction,
} from "../../redux/slices/postsSlice";
import {
  deleteResume as deleteResumeAction,
  getAllResumes as getAllResumesAction,
  inviteCandidatesForInterview as inviteCandidatesForInterviewAction,
  rejectResume as rejectResumeAction,
} from "../../redux/slices/resumeSlice";
import RepostAJobModal from "../../components/Modals/RepostAJob/RepostAJobModal";
import SuccessModal from "../../components/Modals/SuccessModal";
import CSVImportNotification from "../../common/CSVImportNotification";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
/* ============================================================================
<ResumeScreeingCandidates />
============================================================================= */
const ResumeScreeingCandidates = ({
  user,
  resumeData,
  totalResumes,
  getSinglePost,
  getAllResumes,
  rejectResume,
  deleteResume,
  inviteCandidatesForInterview,
  clearPostFormData,
  updatePostFormData,
}) => {
  const { postId } = useParams();

  console.log("postId", postId);
  let post = useSelector((state) => selectPostById(state, postId));
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [rowsPerPage, setRowPerPage] = useState(10);
  const [query, setQuery] = useState("");
  const [filters, setFilters] = useState({});
  const [actionLoading, setActionLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const [inivteModal, setInviteModal] = useState(false);
  // const [uploadResumeModal, setUploadResumeModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [
    selectAssessmentAndCriteriaModal,
    setSelectAssessmentAndCriteriaModal,
  ] = useState(false);
  const [assessmentRequestSentCandidates, setAssessmentRequestSentCandidates] =
    useState([]);
  const [showLanguageSelectModal, setShowLanguageSelectModal] = useState(false);
  const [languagesForInterview, setLangaugesForInterview] = useState([]);
  const [pendingAssessmentId, setPendingAssessmentId] = useState(null);
  const [showNotification, setShowNotification] = useState(
    post?.unprocessed?.unprocessed_count ? true : false
  );
  const [openRepostModal, setOpenRepostModal] = useState(false);
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [activeSubStep, setActiveSubStep] = useState(0);
  const [successModal, setSuccessModal] = useState({
    open: false,
    jobStatus: "",
  });
  const [loading, setLoading] = useState(false);
  const [interviewValue, setInterviewValue] = useState(77);
  const [passingCriteriaSet, setPassingCriteriaSet] = useState(false);

  useEffect(() => {
    if (!post) getSinglePost(postId);
    _getTableData(page, query, filters);
  }, [page]);

  useEffect(() => {
    if (resumeData[page]) {
      setTableData(resumeData[page]);
    }
  }, [resumeData]);

  const updatePostData = async () => {
    await updatePostFormData({
      job_description: post?.job_description,
      id: post?.id,
      region: post?.region,
    });
  };

  useEffect(() => {
    const update = async () => {
      try {
        if (post) {
          await updatePostData(); // make sure this is awaited
        }
      } catch (error) {
        console.log("Error in updating data", error);
      }
    };

    update(); // call the async wrapper

    // Cleanup on unmount
    return () => {
      clearPostFormData();
    };
  }, [post]);

  const _getTableData = useCallback(
    async (_page, _query, _filters, take) => {
      setIsLoading(true);
      await getAllResumes({
        page: _page,
        query: _query,
        filters: _filters,
        job_post_id: postId,
        take,
      });
      setIsLoading(false);
    },
    [page, query, filters, isLoading]
  );

  const onSearch = useCallback(
    (searchQuery) => {
      setPage(1);
      setQuery(searchQuery);
      _getTableData(1, searchQuery, filters);
    },
    [query, page, filters]
  );

  const onFilterChange = useCallback(
    (_filters) => {
      const newFilters = { ...filters, ..._filters };
      setPage(1);
      setFilters(newFilters);
      _getTableData(1, query, newFilters);
    },
    [page, filters]
  );

  const onRefresh = () => _getTableData(page, query, filters);
  const onReset = () => {
    const resetFilters = {};
    setFilters(resetFilters);
    _getTableData(page, query, resetFilters);
  };

  const _handleRowsPerPageChange = (event) => {
    setPage(1);
    setRowPerPage(parseInt(event.target.value, 10));
    _getTableData(1, query, filters, parseInt(event.target.value, 10));
  };

  const handleRejectResumes = useCallback(async () => {
    try {
      setActionLoading("reject");
      await rejectResume({
        ids: selectedRows,
        job_post_id: postId,
        filters: filters,
        query,
      });

      // Calling getData if all resumes selected if not then updating redux directly
      if (selectedRows === "all") await _getTableData(1, query, filters);
    } catch (e) {
      enqueueSnackbar("Something went wrong while rejecting resumes", {
        variant: "error",
      });
    } finally {
      setActionLoading(false);
      setSelectedRows([]);
    }
  }, [selectedRows?.length, page, query, filters, actionLoading]);

  const handleDeleteResumes = useCallback(async () => {
    try {
      setActionLoading("delete");
      await deleteResume({
        ids: selectedRows,
        job_post_id: postId,
        filters: filters,
        query,
      });

      await _getTableData(1, query, filters);
    } catch (e) {
      enqueueSnackbar("Something went wrong while deleting resumes", {
        variant: "error",
      });
    } finally {
      setActionLoading(false);
      setSelectedRows([]);
    }
  }, [selectedRows?.length, page, query, filters, actionLoading]);

  const handleSendAssessmentRequest = useCallback(
    async (usersToRequest, assessment_id = post?.assesment_id) => {
      // TODO STEPS
      // 1. CHECK IF POST ALREADY HAVE ASSESSMENT
      // 2. IF NOT THEN OPEN Select Assessments and criteria modal
      // 3. IF assesment is present the call invite candidate to interivew api
      // 4. After api call reset "AssessmentRequestSentCandidates" state

      setAssessmentRequestSentCandidates(usersToRequest);

      if (!assessment_id && !pendingAssessmentId) {
        return setSelectAssessmentAndCriteriaModal(true);
      }
      if (languagesForInterview?.length === 0) {
        return setShowLanguageSelectModal(true);
      }

      try {
        setActionLoading("invite");
        await inviteCandidatesForInterview({
          job_post_id: postId,
          // assessment_id,
          assessment_id: assessment_id || pendingAssessmentId,
          company_id: user?.company_id,
          resume_ids: usersToRequest,
          filters,
          query,
          languages: languagesForInterview,
          passing_criteria: {
            interview_passing_criteria: interviewValue,
          },
        });

        // Clear everything after success
        setAssessmentRequestSentCandidates([]);
        setSelectedRows([]);
        setLangaugesForInterview([]);
        setPendingAssessmentId(null);
        setShowLanguageSelectModal(false);
        setPassingCriteriaSet(false);
        setInterviewValue(77);
        await clearPostFormData();

        await _getTableData(1, query, filters);
      } catch (e) {
        enqueueSnackbar(
          "Something went wrong while sending assessment request",
          { variant: "error" }
        );
      } finally {
        setActionLoading(false);
      }
    },
    [
      selectedRows?.length,
      query,
      filters,
      languagesForInterview,
      pendingAssessmentId,
    ]
  );

  const onNext = (skip) => {
    setTriggerValidation(true);
  };

  const onBack = () => {
    if (activeSubStep > 0) {
      setActiveSubStep((prev) => prev - 1);
    } else if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
      setActiveSubStep(steps[activeStep - 1]?.subSteps?.length - 1 || 0);
    }
  };

  const _handleClose = async () => {
    await clearPostFormData();
    setOpenRepostModal(false);
    setTriggerValidation(false);
  };

  const handleDownload = () => {
    setIsDownloading(true);

    const csvUrl = post?.unprocessed?.csv_link;

    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = "failed_records.csv"; // Optional: custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Simulate download delay
    setTimeout(() => {
      setIsDownloading(false);
    }, 2000); // Adjust this as needed
  };

  const handleClose = () => {
    // Your close notification logic here
    setShowNotification(false);
    console.log("Notification closed");
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <Card
        sx={{
          height: "100%",
          position: "relative",
          left: "230px",
          width: "calc(100% - 230px)",
          mt: "4%",
        }}
      >
        <Box
          display="flex"
          p={2}
          borderBottom="1px solid #d1d1d1"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <IconButton
              size="small"
              sx={{ border: "1px solid #B1B1B1" }}
              onClick={() => navigate(-1)}
            >
              <ChevronLeft sx={{ fontSize: 18, color: "#B1B1B1" }} />
            </IconButton>
            <Typography
              fontSize={{ xs: "14px", md: "18px" }}
              fontWeight={600}
              color="#48555E"
            >
              {post?.job_name}
            </Typography>
          </Box>
          <Box>
            {/* <Button
              variant="main"
              onClick={() => setInviteModal(true)}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                fontFamily: "Outfit",
                borderRadius: { xs: "5px", md: "30px" },
              }}
            >
              Invite +
            </Button> */}
            {/* {(post?.flow === "1" || post?.flow === "4") && (
              <Button
                variant="main"
                sx={{
                  ml: 1,
                  fontSize: 14,
                  fontWeight: 500,
                  bgcolor: "#762FDE",
                  fontFamily: "Outfit",
                  borderRadius: { xs: "5px", md: "30px" },
                }}
                onClick={async () => {
                  await updatePostData();
                  setOpenRepostModal(true);
                }}
              >
                Repost job
              </Button>
            )} */}
          </Box>
        </Box>

        {showNotification && (
          <Box px={2} py={1}>
            <CSVImportNotification
              onClose={handleClose}
              onDownload={handleDownload}
              isDownloading={isDownloading}
              totalRecords={post?.resume_received}
              successfulRecords={post?.resume_parsed}
              failedRecords={post?.unprocessed?.unprocessed_count}
            />
          </Box>
        )}

        <Box
          px={2}
          pb={1}
          height={showNotification ? "80%" : "100%"}
          overflow="auto"
        >
          <ResumeScreeningCandidatesTableHeader
            actionLoading={actionLoading}
            onSearch={onSearch}
            filters={filters}
            onReload={onRefresh}
            tableDataLength={tableData?.length}
            selectedRows={selectedRows}
            onReset={onReset}
            onFilterChange={onFilterChange}
            onRejectResumes={handleRejectResumes}
            onDeleteResumes={handleDeleteResumes}
            onRequestAssesment={handleSendAssessmentRequest}
          />
          <ResumeScreeningCandidatesTable
            isLoading={isLoading}
            page={page}
            setPage={setPage}
            getData={onRefresh}
            tableData={tableData}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            onRequestAssesment={handleSendAssessmentRequest}
          />
          {tableData?.length > 0 && (
            <TablePagination
              component="div"
              count={totalResumes}
              page={page - 1}
              onPageChange={(_, newPage) => setPage(newPage + 1)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={_handleRowsPerPageChange}
              sx={{
                fontFamily: "Outfit",
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                  {
                    fontFamily: "Outfit",
                  },
                "& .MuiInputBase-root": {
                  fontFamily: "Outfit",
                },
              }}
            />
          )}
        </Box>

        {/* <UploadResumesModal open={uploadResumeModal} onClose={() => setUploadResumeModal(false)} /> */}

        <InviteCandidatesModal
          open={inivteModal}
          onClose={() => setInviteModal(false)}
        />

        <SelectAssesmentAndCriteriaModal
          open={selectAssessmentAndCriteriaModal}
          onClose={() => {
            setPassingCriteriaSet(false);
            setLangaugesForInterview([]);
            setSelectAssessmentAndCriteriaModal(false);
          }}
          onSelect={(assessmentId) => {
            setSelectAssessmentAndCriteriaModal(false);
            setPendingAssessmentId(assessmentId);
            handleSendAssessmentRequest(
              assessmentRequestSentCandidates,
              assessmentId
            );
          }}
        />

        <SelectLanguageModal
          open={showLanguageSelectModal}
          actionLoading={actionLoading}
          passingCriteriaSet={passingCriteriaSet}
          setPassingCriteriaSet={setPassingCriteriaSet}
          interviewValue={interviewValue}
          setInterviewValue={setInterviewValue}
          setShowLanguageSelectModal={setShowLanguageSelectModal}
          onClose={() => {
            setPendingAssessmentId(null);
            setShowLanguageSelectModal(false);
            setLangaugesForInterview([]);
            setPassingCriteriaSet(false);
          }}
          onSelect={(selectedLanguages) => {
            console.log("selected", selectedLanguages);
            setLangaugesForInterview(selectedLanguages);
          }}
          onConfirm={() => {
            handleSendAssessmentRequest(assessmentRequestSentCandidates);
          }}
        />
        <RepostAJobModal
          open={openRepostModal}
          onClose={_handleClose}
          activeStep={activeStep}
          activeSubStep={activeSubStep}
          setActiveSubStep={setActiveSubStep}
          setActiveStep={setActiveStep}
          onNext={onNext}
          onBack={onBack}
          setSuccessModal={setSuccessModal}
          steps={steps}
          triggerValidation={triggerValidation}
          setTriggerValidation={setTriggerValidation}
          loading={loading}
          updatePostFormData={updatePostFormData}
          post={post}
          flag={true}
        />

        <SuccessModal
          open={successModal?.open}
          onClose={() => navigate("/posts")}
          title={
            successModal?.jobStatus === "scheduled"
              ? "Post Scheduled"
              : "Post Shared"
          }
          description={
            successModal?.jobStatus === "scheduled"
              ? "Your job post has been scheduled successfully"
              : "Your job post is shared successfully"
          }
          onBtnClick={() => navigate("/posts")}
        />
      </Card>
    </>
  );
};

const steps = [
  {
    label: "Post a job",
    icon: <CheckCircle sx={{ width: "1.4rem", height: "1.4rem" }} />,
    subSteps: [
      { label: "Set up the template and content for social media display" },
      { label: "Post a job" },
    ],
  },
];

const mapStateToProps = (state) => ({
  user: state.auth.user,
  totalResumes: state.resume.totalResumes,
  resumeData: state.resume.resumeData,
});

const mapDipatchToProps = {
  deleteResume: deleteResumeAction,
  rejectResume: rejectResumeAction,
  getSinglePost: getSinglePostAction,
  getAllResumes: getAllResumesAction,
  inviteCandidatesForInterview: inviteCandidatesForInterviewAction,
  clearPostFormData: clearPostFormDataAction,
  updatePostFormData: updatePostFormDataAction,
};

/* Export
============================================================================= */
export default connect(
  mapStateToProps,
  mapDipatchToProps
)(ResumeScreeingCandidates);
